import { ArrowUpRight } from "lucide-react";
import { BRAND_ASSETS } from "@/utils/brandAssets";
import { ECOSYSTEM_LINKS } from "@/utils/ecosystemLinks";
import { trackHubEvent } from "@/utils/hub";

const DESTINATIONS = [
  {
    id: "integratednycai",
    eyebrow: "Integrated clinical intelligence",
    title: "See your health as one connected system.",
    copy: "Bring goals, symptoms, labs, wearables, body composition, genetics, and history into one evolving Clinical Performance Index.",
    cta: "Explore clinical intelligence",
    href: ECOSYSTEM_LINKS.intelligence.home,
    image: BRAND_ASSETS.clinicalScan,
    alt: "Integrated Wellness clinical intelligence and body data",
  },
  {
    id: "iwoptimizeme",
    eyebrow: "Nine connected programs",
    title: "Optimize your whole health.",
    copy: "Medically supervised, data-driven programs for body transformation, metabolic health, longevity, performance, and more.",
    cta: "Explore optimization programs",
    href: ECOSYSTEM_LINKS.optimize.home,
    image: BRAND_ASSETS.programLongevity,
    alt: "Integrated Wellness longevity optimization program",
  },
  {
    id: "homebloodkit",
    eyebrow: "Lab-grade testing at home",
    title: "Turn blood work into next steps.",
    copy: "Validated at-home panels with RedDrop One collection, clinician-reviewed results, and Clinical Performance Index guidance.",
    cta: "Shop at-home test kits",
    href: ECOSYSTEM_LINKS.labs.home,
    image: BRAND_ASSETS.homeBloodKit,
    alt: "HomeBloodKit at-home blood collection kit",
  },
];

export function EcosystemCtas() {
  return <section className="iw-grid-bg bg-surface-light py-12 md:py-14" data-testid="ecosystem-cta-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl"><p className="font-mono text-[10px] uppercase text-brand-red">§ Integrated Wellness Network</p><h2 className="mt-3 font-heading text-3xl font-bold text-navy sm:text-4xl">From local discovery to <span className="text-brand-red">personal action.</span></h2><p className="mt-4 max-w-2xl font-body text-base leading-relaxed text-gray-600">Connect venue discovery with clinical intelligence, at-home lab testing, and data-driven optimization programs.</p></div>
      <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-3">
        {DESTINATIONS.map((destination) => <article key={destination.id} className="clinical-frame flex min-w-0 flex-col overflow-hidden border-2 border-navy/10 bg-white" data-testid={`ecosystem-card-${destination.id}`}>
          <div className="relative aspect-[21/9] overflow-hidden bg-slate-100"><img src={destination.image} alt={destination.alt} className="absolute inset-0 h-full w-full object-cover" loading="lazy" data-testid={`ecosystem-image-${destination.id}`} /></div>
          <div className="flex flex-1 flex-col p-5"><p className="font-mono text-[10px] uppercase text-brand-red">{destination.eyebrow}</p><h3 className="mt-2 font-heading text-xl font-bold text-navy">{destination.title}</h3><p className="mt-2 flex-1 font-body text-sm leading-relaxed text-gray-600">{destination.copy}</p><a href={destination.href} target="_blank" rel="noopener noreferrer" onClick={() => trackHubEvent("ecosystem_cta_click", null, { destination: destination.id, placement: "homepage" })} className="mt-5 inline-flex min-h-[44px] items-center gap-2 self-start bg-brand-red px-5 py-3 font-mono text-[10px] font-bold uppercase text-white transition-colors hover:bg-red-800" data-testid={`ecosystem-cta-${destination.id}`}>{destination.cta} <ArrowUpRight className="h-4 w-4" /></a></div>
        </article>)}
      </div>
    </div>
  </section>;
}